import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const handleLogout = () => { logout(); navigate('/'); setMenuOpen(false); };
  const isActive = (p) => location.pathname === p || location.pathname.startsWith(p + '/');

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <span className="logo-half">half</span><span className="logo-price">price</span><span className="logo-tld">.ca</span>
        </Link>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/deals" className={isActive('/deals') ? 'active' : ''} onClick={() => setMenuOpen(false)}>Browse deals</Link>
          <Link to="/how-it-works" className={isActive('/how-it-works') ? 'active' : ''} onClick={() => setMenuOpen(false)}>How it works</Link>
          <Link to="/pricing" className={isActive('/pricing') ? 'active' : ''} onClick={() => setMenuOpen(false)}>Pricing</Link>

          {/* Mobile-only: shown inside dropdown since action buttons hide on mobile */}
          {user?.type === 'business' && (
            <>
              <Link to="/business/dashboard" className="hide-desktop mobile-menu-extra" onClick={() => setMenuOpen(false)}>📊 My dashboard</Link>
              <button className="hide-desktop mobile-menu-extra mobile-logout-btn" onClick={handleLogout}>Log out</button>
            </>
          )}
          {!user && (
            <Link to="/business/login" className="hide-desktop mobile-menu-extra" onClick={() => setMenuOpen(false)}>Business login</Link>
          )}
        </div>
        <div className="navbar-actions">
          {user?.type === 'business' ? (
            <>
              <Link to="/business/dashboard" className="btn btn-ghost btn-sm hide-mobile">Dashboard</Link>
              <button onClick={handleLogout} className="btn btn-outline btn-sm hide-mobile">Log out</button>
            </>
          ) : (
            <>
              <Link to="/business/login" className="btn btn-ghost btn-sm hide-mobile">Business login</Link>
              <Link to="/business/register" className="btn btn-primary btn-sm">List your restaurant</Link>
            </>
          )}
          <button className="navbar-burger hide-desktop" aria-label="Menu" onClick={() => setMenuOpen(!menuOpen)}>
            <span /><span /><span />
          </button>
        </div>
      </div>
    </nav>
  );
}
